export default __webpack_public_path__ + "assets/images/e6b2fd7b70f3e1449539a4d17dd3ab2d.png";